import type { FC } from 'react';
import React, { useContext, useEffect, useState } from 'react';

import { RicosContext } from './../../ricos-context';
import { useModalService } from './../../ricos-modals/modal-service-provider';
import type { IToolbarItem } from './../../ricos-types';
import { ToggleButton } from './../../toolbars-ui';

import DesignIcon from '../assets/icons/DesignIcon';

type Props = {
  toolbarItem: IToolbarItem;
  dataHook?: string;
};

export const PollDesignButton: FC<Props> = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);
  const [isActive, setIsActive] = useState(toolbarItem.attributes.active);
  const modalService = useModalService();

  useEffect(() => {
    modalService.onModalOpened(() => {
      setIsActive(Boolean(toolbarItem.attributes.active));
    });

    modalService.onModalClosed(() => {
      setIsActive(Boolean(toolbarItem.attributes.active));
    });
  }, [modalService]);

  return (
    <ToggleButton
      Icon={DesignIcon}
      onClick={() => toolbarItem.commands?.click({ referenceElement })}
      dataHook={dataHook}
      active={isActive}
      tooltip={t('Poll_PollSettings_Tab_Design_TabName')}
      setRef={setReferenceElement}
    />
  );
};
